/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { Layer } from '@carbon/react';

export const Container = styled.main`
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 12px;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export const Section = styled(Layer)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${({ $orientation }) => ($orientation === 'left' ? '' : '0 16px 16px 16px')};
  background-color: ${({ $orientation }) => ($orientation === 'left' ? '' : 'white')};
  gap: 10px;
  overflow-y: auto;
  max-height: ${({ $isExtractionStepNotificationExists }) => ($isExtractionStepNotificationExists ? '66vh' : '73vh')};
`;

export const CalloutNotificationContainer = styled.div`
  padding-bottom: 20px;

  .cds--actionable-notification,
  .cds--inline-notification {
    /*
     * This is added to allow notification to span the entire width of the screen.
     */
    max-inline-size: 100%;
  }
`;

export const LoaderContainer = styled.div`
  margin: 0 auto;
`;
